/**
 * Created by pajicv on 9/25/18.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
//import IconButton from '@material-ui/core/IconButton';
//import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import {
  AppBar, Toolbar, Typography, IconButton,
  Menu, MenuItem, Avatar, Tooltip
} from '@material-ui/core';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import Dropzone from 'react-dropzone';
import { auth } from '../../firebase';
import * as routes from '../../routes/routes';
import { withRouter } from 'react-router-dom';
import Badge from '@material-ui/core/Badge';
import Notifications from '@material-ui/icons/Notifications'
import { getNotifications, readNotification, getLogoImg, getUsersManagerProjects } from '../../firebase/db';
import { uploadLogoPicture } from '../../firebase/storage';
import { db } from '../../firebase/firebase';
import HeaderTabs from './HeaderTabs';
import OverlayContainer from '../Overlay/OverlayContainer';
import { Base64 } from 'js-base64';
import { FIREBASE_PROJECT_ID, MAIN_COLOR } from '../../firebase-config';
import { toast } from 'react-toastify';
const styles = theme => ({
  root: {
    width: '100%',
    borderTop: '10px solid ' + MAIN_COLOR,
  },
  grow: {
    flexGrow: 1
  },
  menuButton: {
    marginLeft: -12,
    marginRight: 20
  },
  title: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)'
  },
  userMenuContainer: {
    right: 95,
    position: 'absolute'
  },
  username: {
    fontSize: 20,
    marginLeft: 10
  },
  upgradeButton: {
    position: 'relative',
    borderRadius: 20,
    marginLeft: 0,
    width: 150
  },
  avatar: {
    color: theme.palette.primary
  },
  rowLogo: {
    display: 'flex',
    flexDirection: 'row'
  }
});

class TitleBar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      anchorEL: null,
      anchorElNot: null,
      role: routes.DASHBOARD,
      isOverlayOpen: false,
      selectedTask: null,
      selectedCycle: null,
      selectedProject: null,
      taskRole: null,
      logoImg: '',
      projects: {}
    };
  }
  componentWillMount() {
    auth.getUser(user => {
      if (user) {
        this.setState({
          authenticated: true,
          currentUser: user,
          loading: false
        });
      } else {
        this.setState({
          authenticated: false,
          currentUser: null,
          loading: false
        });
      }
    });
  }

  componentDidMount() {
    db.ref('notifications').on('child_added', () => {
      getNotifications(this.props.email)
        .then((notifications) => {
          this.setState({ notifications: notifications.filter(x => x) });
        }).catch((error) => {
        })
    });
    db.ref('notifications').on('child_changed', () => {
      getNotifications(this.props.email)
        .then((notifications) => {
          this.setState({ notifications: notifications.filter(x => x) });
        }).catch((error) => {
        })
    });
    db.ref('notifications').on('child_removed', () => {
      getNotifications(this.props.email)
        .then((notifications) => {
          this.setState({ notifications: notifications.filter(x => x) });
        }).catch((error) => {
        })
    });
    db.ref('logo').limitToLast(1).on('child_added', () => {
      getLogoImg()
        .then((logoImg) => {
          this.setState({ logoImg })
        }).catch((error) => {
          console.log('error', error);
        })
    })
    db.ref('logo').limitToLast(1).on('child_changed', () => {
      getLogoImg()
        .then((logoImg) => {
          this.setState({ logoImg })
        }).catch((error) => {
          console.log('error', error);
        })
    })
    db.ref('projects').limitToLast(1).on('child_added', () => {
      getUsersManagerProjects(this.props.email)
        .then((projects) => {
          this.setState({
            projects: projects
          })
        })
    })
    db.ref('projects').limitToLast(1).on('child_changed', () => {
      getUsersManagerProjects(this.props.email)
        .then((projects) => {
          this.setState({
            projects: projects
          })
        })
    })
    db.ref('projects').limitToLast(1).on('child_removed', () => {
      getNotifications(this.props.email)
        .then((notifications) => {
          this.setState({ notifications: notifications.filter(x => x) });
        }).catch((error) => {
        })
    })
    db.ref('cycles').limitToLast(1).on('child_removed', () => {
      getNotifications(this.props.email)
        .then((notifications) => {
          this.setState({ notifications: notifications.filter(x => x) });
        }).catch((error) => {
        })
    })
    db.ref('tasks').limitToLast(1).on('child_removed', () => {
      getNotifications(this.props.email)
        .then((notifications) => {
          this.setState({ notifications: notifications.filter(x => x) });
        }).catch((error) => {
        })
    })
    db.ref('subTasks').on('child_removed', () => {
      getNotifications(this.props.email)
        .then((notifications) => {
          this.setState({ notifications: notifications.filter(x => x) });
        }).catch((error) => {
        })
    })
    this.props.history.listen((location, action) => {
      if (location.pathname.includes('/tasks')) {
        this.setState({
          role: 'tasks'
        })
      } else if (location.pathname.includes('/dashboard')) {
        this.setState({
          role: 'dashboard'
        })
      } else if (location.pathname.includes('/team')) {
        this.setState({
          role: 'team'
        })
      } else if (location.pathname.includes('/documents')) {
        this.setState({
          role: 'documents'
        })
      }
    });

    window.onload = this.handleRoute()
  }


  handleRoute = () => {
    if (window.location.pathname.includes('/tasks')) {
      this.setState({
        role: 'tasks'
      })
    } else if (window.location.pathname.includes('/dashboard')) {
      this.setState({
        role: 'dashboard'
      })
    } else if (window.location.pathname.includes('/team')) {
      this.setState({
        role: 'team'
      })
    } else if (window.location.pathname.includes('/documents')) {
      this.setState({
        role: 'documents'
      })
    }
  }


  componentDidUpdate(prevProps) {
    if (prevProps.email !== this.props.email && this.props.email !== null) {
      db.ref('notifications').on('child_added', () => {
        getNotifications(this.props.email)
          .then((notifications) => {
            this.setState({ notifications: notifications.filter(x => x) });
          }).catch((error) => {
          })
      });
      db.ref('notifications').on('child_changed', () => {
        getNotifications(this.props.email)
          .then((notifications) => {
            this.setState({ notifications: notifications.filter(x => x) });
          }).catch((error) => {
          })
      });
      db.ref('notifications').on('child_removed', () => {
        getNotifications(this.props.email)
          .then((notifications) => {
            this.setState({ notifications: notifications.filter(x => x) });
          }).catch((error) => {
          })
      });
    }
  }

  handleClick = event => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };


  handleClickNot = event => {
    this.setState({ anchorElNot: event.currentTarget });
  };

  handleCloseNot = () => {
    this.setState({ anchorElNot: null });
  };

  handleLogoutClick = () => {
    this.props.onLogout();
    this.handleClose();
  };


  handleNotificationRead = (row) => {
    const { email, history, auth } = this.props;
    const title = row.project.title
    readNotification(email, row.notId)
      .then(() => {
        const taskRole = row.project.members[Base64.encode(auth.email)];
        this.setState({ selectedProject: row.subTask.project, selectedCycle: row.subTask.cycle, selectedTask: row.subTask.task, taskRole, isOverlayOpen: true, row, title });
        //history.push('worker_task_detail', { row, title, auth });
      });
  }

  handleDropPicture = ({ accepted, rejected }) => {
    if (rejected.length > 0) {
      toast.error("Unsuported file type or file too large!", {
        position: "top-center",
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
      });
    } else if (!!accepted && accepted.length !== 0) {
      this.props.onDropPicture(accepted);
    }
  }

  handleLogoUpload = ({ accepted, rejected }) => {
    const { auth } = this.props;
    if (rejected.length > 0) {
      toast.error("Unsuported file type or file too large!", {
        position: "top-center",
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
      });
    } else
      if (!!accepted && accepted.length !== 0) {
        uploadLogoPicture(auth.email, accepted[0])
      }
  }

  onImageClick = (e) => {
    e.preventDefault();
    const { currentUser } = this.state;
    const { history } = this.props
    if (currentUser) {
      this.setState({
        role: 'dashboard'
      })
      history.push(routes.DASHBOARD);
    } else {
      history.push(routes.LOGIN);
    }
  };

  handleChangeTab = (e, role) => {
    this.setState({ role });
    const { history } = this.props;
    history.push(role);
  };

  handleOverlayClose = () => {
    this.setState({ selectedProject: null, selectedCycle: null, selectedTask: null, taskRole: null, isOverlayOpen: false, row: null, title: null });
  };

  render() {
    let dropzoneRef;
    const { classes, username } = this.props;
    const { anchorEl, currentUser, notifications, anchorElNot, isOverlayOpen, selectedProject, selectedCycle, selectedTask, taskRole, row, title, logoImg, projects } = this.state;
    const open = Boolean(anchorEl);
    const openNot = Boolean(anchorElNot);
    let notificationCounter = <img src={require('../../icons/bell.svg')} height="22" width="22" alt="Notifications" />;
    let notificationsInfo;
    if (notifications && notifications.filter(function (obj) { return obj.notification.read === false }).length) {
      notificationCounter = <Badge badgeContent={notifications.filter(function (obj) { return obj.notification.read === false }).length} color="primary" style={{ zIndex: '1' }}>
        <img src={require('../../icons/bell.svg')} height="22" width="22" alt="Notifications" />
      </Badge>
      notificationsInfo = notifications.filter(function (obj) { return obj.notification.read === false }).map((not, i) => {
        return <MenuItem onClick={() => this.handleNotificationRead(not)}>{not.notification.title + '\n' + not.notification.message}</MenuItem>
      })
    } else {
      notificationsInfo = <MenuItem>No new notifications!</MenuItem>;
    }
    return (
      <div className={classes.root}>
        <AppBar color="white" elevation={0} position="static">
          <Toolbar>

            {currentUser && currentUser.emailVerified &&
              // <Typography variant="title"
              //   color="inherit"
              //   noWrap
              // >
              //   <img src={require('../../logoUX.png')} style={{ marginLeft: "50px" }} width="100" height="90" alt="Logo" onClick={this.onImageClick} />
              // </Typography>
              <div className={classes.rowLogo}>
                <Dropzone
                  accept={['image/jpeg', 'image/png', 'image/bmp', 'image/svg+xml', 'image/gif']}
                  maxSize={10485760}
                  className="dropZone-profile"
                  multiple={false}
                  ref={(node) => { dropzoneRef = node; }}
                  onDrop={(accepted, rejected) => this.handleLogoUpload({ accepted, rejected })}
                >
                  {({ isDragActive, isDragReject, acceptedFiles, rejectedFiles }) => {
                    return
                  }}
                </Dropzone>
                {this.state.logoImg ? <img style={{ marginLeft: "50px" }} width="100" height="90" alt="Logo" onClick={this.onImageClick}
                  src={logoImg.image}
                /> : (
                    <div>
                      <img src={FIREBASE_PROJECT_ID === 'uxs-autumn' ? require('../../logoUX.png') : require('../../cy-x_logo.png')} style={{ marginLeft: "50px" }} width="100" height="90" alt="Logo" onClick={this.onImageClick} />
                    </div>
                  )}
                {(Object.keys(projects).length > 0 && FIREBASE_PROJECT_ID !== 'uxs-autumn') &&
                  <IconButton
                    onClick={() => { dropzoneRef.open() }}
                  >
                    <MoreVertIcon />
                  </IconButton>
                }
              </div>
            }
            {(FIREBASE_PROJECT_ID !== 'uxs-autumn' && !currentUser && (currentUser && !currentUser.emailVerified)) &&
              < div >
                <img src={require('../../cy-x_logo.png')} style={{ marginLeft: "50px" }} width="100" height="90" alt="Logo" onClick={this.onImageClick} />
              </div>
            }
            {currentUser && currentUser.emailVerified &&
              <div className={classes.title}>
                <HeaderTabs role={this.state.role} onChangeRole={this.handleChangeTab} />
              </div>
            }
            {currentUser && currentUser.emailVerified &&
              <Toolbar className={classes.userMenuContainer}>

                <Dropzone
                  accept={['image/jpeg', 'image/png', 'image/bmp', 'image/svg+xml', 'image/gif']}
                  maxSize={10485760}
                  className="dropZone-profile"
                  multiple={false}
                  onDrop={(accepted, rejected) => this.handleDropPicture({ accepted, rejected })}
                >
                  {({ isDragActive, isDragReject, acceptedFiles, rejectedFiles }) => {
                    return this.props.imgURL ? <Tooltip title={currentUser.email}>
                      <Avatar
                        src={this.props.imgURL}
                        className="userProfile-avatar"
                      /></Tooltip> : (
                        <Tooltip title={currentUser.email}>
                          <Avatar style={{ backgroundColor: MAIN_COLOR }} className="userProfile-avatar">
                            {username.substring(0, 2).toUpperCase()}
                          </Avatar>
                        </Tooltip>
                      )
                  }}
                </Dropzone>
                <IconButton
                  aria-label="More"
                  aria-owns={open ? 'long-menu' : null}
                  aria-haspopup="true"
                  onClick={this.handleClick}
                >
                  <MoreVertIcon />
                </IconButton>
                <IconButton
                  aria-label="More"
                  aria-owns={open ? 'notifications-menu' : null}
                  aria-haspopup="true"
                  onClick={this.handleClickNot}>
                  {notificationCounter}
                </IconButton>
                <Menu
                  id="long-menu"
                  anchorEl={anchorEl}
                  open={open}
                  onClose={this.handleClose}
                >
                  <MenuItem onClick={this.handleLogoutClick}>Logout</MenuItem>
                </Menu>
                <Menu
                  id="notifications-menu"
                  anchorEl={anchorElNot}
                  open={openNot}
                  onClose={this.handleCloseNot}
                >
                  {notificationsInfo}
                </Menu>
              </Toolbar>
            }
          </Toolbar>
        </AppBar>
        {isOverlayOpen && <OverlayContainer
          projectId={selectedProject}
          cycleId={selectedCycle}
          taskId={selectedTask}
          onOverlayClose={this.handleOverlayClose}
          role={taskRole}
          overlayLevel={0}
          row={row}
          title={title}
        />}
      </div>
    )
  }
};

TitleBar.propTypes = {
  classes: PropTypes.object.isRequired,
  title: PropTypes.string,
  username: PropTypes.string,
  role: PropTypes.string
};

TitleBar.defaultProps = {
  title: '',
  username: '',
  role: ''
};

export default withStyles(styles)(withRouter(connect(state => ({
  auth: state.firebase.auth,
}))(TitleBar)));



// WEBPACK FOOTER //
// ./src/components/common/HeaderBar.js